<div class="modal-header">
  <h6 class="modal-title">
    Select From Course and Subject
    <i
      class="fa fa-info-circle ms-2"
      data-bs-toggle="tooltip"
      data-bs-placement="right"
      title="Select the destination subject where you want to clone the study unit and materials"
      style="cursor: pointer"
    ></i>
  </h6>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="cancel()"
  ></button>
</div>

<div class="modal-body">
  <form [formGroup]="cloneForm">
    <!-- Exam Agency -->
    <div class="form-group row mb-1 align-items-center">
      <label for="examAgencySelect" class="col-sm-3 col-form-label text-end">
        Exam Agency
      </label>
      <div class="col-sm-9">
        <select
          class="form-select"
          id="examAgencySelect"
          formControlName="examAgency"
          (change)="getCourses($event)"
        >
          <option value="">Select Exam Agency</option>
          <option *ngFor="let agency of examAgencies" [value]="agency.Code">
            {{ agency.Name }}
          </option>
        </select>
      </div>
    </div>

    <!-- Course -->
    <div class="form-group row mb-1 align-items-center">
      <label for="courseSelect" class="col-sm-3 col-form-label text-end">
        Course
      </label>
      <div class="col-sm-9">
        <select
          class="form-select"
          id="courseSelect"
          formControlName="course"
          (change)="getYears($event)"
          [disabled]="courses.length === 0"
        >
          <option value="">Select Course</option>
          <option *ngFor="let course of courses" [value]="course.Code">
            {{ course.Name }}
          </option>
        </select>
      </div>
    </div>

    <!-- Year -->
    <div class="form-group row mb-3 align-items-center">
      <label for="yearSelect" class="col-sm-3 col-form-label text-end">
        Year
      </label>
      <div class="col-sm-9">
        <select
          class="form-select"
          id="yearSelect"
          formControlName="year"
          (change)="getCourseSubjects($event)"
          [disabled]="years.length === 0"
        >
          <option value="">Select Year</option>
          <option *ngFor="let year of years" [value]="year.Code">
            {{ year?.Name }}
          </option>
        </select>
      </div>
    </div>

    <!-- Subject -->
    <div class="form-group row mb-1 align-items-center">
      <label for="subjectSelect" class="col-sm-3 col-form-label text-end">
        Subject
      </label>
      <div class="col-sm-9">
        <select
          class="form-select"
          id="subjectSelect"
          formControlName="subject"
          (change)="onSubjectChange($event)"
          [disabled]="subjects.length === 0"
        >
          <option value="">Select Subject</option>
          <option *ngFor="let subject of subjects" [value]="subject.Code">
            {{ subject?.Name }}
          </option>
        </select>
      </div>
    </div>
  </form>

  <div *ngIf="showAlert" class="d-flex justify-content-center">
    <small class="text-danger">
      Subjects for this course are yet to be added. Go to Course Management >
      Course Subject screen and select the subjects relevant to this course
    </small>
  </div>
</div>

<div class="modal-footer">
  <button
    type="button"
    class="btn btn-sm bl-btn"
    [disabled]="selectbutton"
    (click)="selectAndClose()"
  >
    Select
  </button>
  <button type="button" class="btn btn-sm bg-light border" (click)="cancel()">
    Cancel
  </button>
</div>
